import { t } from '@lingui/core/macro';
import { AvatarList, TeamAvatar, UserAvatar } from '@pocketlaw/tetris';
import { useDraftPreview } from '../../../DraftPreviewProvider';
import { AvatarContainer } from './styled';
export function MetadataApprovers() {
    const { approvers: users, teamApprovers: teams } = useDraftPreview();
    const deletedUser = t({
        message: 'Deleted user',
        comment: 'Fallback name when user does not exist',
    });
    const deletedTeam = t({
        message: 'Unknown team',
        comment: 'Fallback name when team does not exist',
    });
    if (users.length === 0 && teams.length === 0) {
        return null;
    }
    return (<AvatarContainer>
      <AvatarList limit={10}>
        {users.map((user) => (<UserAvatar key={user === null || user === void 0 ? void 0 : user.id} title={(user === null || user === void 0 ? void 0 : user.name) || deletedUser}/>))}
        {teams.map((team) => (<TeamAvatar key={team === null || team === void 0 ? void 0 : team.id} title={(team === null || team === void 0 ? void 0 : team.name) || deletedTeam}/>))}
      </AvatarList>
    </AvatarContainer>);
}
